export default __webpack_public_path__ + "2629d43a923ebb7ef324a3b5e7205c25.svg";